import { render, staticRenderFns } from "./TransportModal.vue?vue&type=template&id=31f9f533&"
import script from "./TransportModal.vue?vue&type=script&lang=js&"
export * from "./TransportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports